import React from 'react'
import styled from "styled-components";
import { useStateValue } from './StateProvider';
import { getBasketTotal } from './reducer';
import numeral from 'numeral';
import { useHistory } from 'react-router-dom';
import { auth } from "../firebase";

function Subtotal() {
  const history = useHistory();
  const [{basket, user}, dispatch] = useStateValue();
  const subtotal = getBasketTotal(basket);
  const formattedSubtotal = numeral(subtotal).format('$0,0.00');

  const checkout = e => {
    auth.onAuthStateChanged(authUser => {
      if (authUser) {
        dispatch({
          type: 'SET_USER',
          user: authUser,
        });
        history.push('/checkout')
      } else {
        alert("You need to create an account before you can checkout")
        history.push('/register')
      }
    })
  }

  return (   
    <Container>
      <>
    <h2>Cart Summary</h2>
    <Content>
      <Calculation>
        <h4>Subtotal ({basket?.length} items) :</h4>
        <h3>{formattedSubtotal}</h3>
      </Calculation>
      <p>Delivery fees not included</p>
    </Content>
    <CheckOutButton onClick={checkout}>
        Checkout ({formattedSubtotal})
    </CheckOutButton>
  </>
        <br /><br />
    </Container>
  )
}

const Container = styled.div`
  width: 30vw;
  height: max-content;
  align-items: center;
  justify-content: center;
  background: white;
  margin-top: 10%;
  margin-left: -2%;
  box-shadow: 0 0 0 1px rgb(0 0 0 / 15%), 0 0 0 rgb(0 0 0 / 20%);

  @media(max-width: 900px) {
    width: 50vw;
    align-self: center;
    margin-top: -1%;
    margin-left: 0;
  }

  @media(max-width: 550px) {
    width: 90vw;
  }

  @media (min-height: 1085px) {
    width: 60vw;
  }

  h2 {
    text-align: center;
    padding-top: 15px;
    font-weight: 400;
    text-decoration: underline;

    @media(max-width: 768px) {
      font-size: 20px;
    }
  }
`;

const Content = styled.div`
  border-bottom: 1px solid gray;
  background: white;
  align-items: center;
  justify-content: center;

  p {
    margin-top: -2%;
    margin-left: 2%;

    @media (min-height: 1085px) {
      font-size: 20px; 
  }
  }
`;

const Calculation = styled.div`
  line-height: 0.5;
  display: flex;
  justify-content: space-between;

  h4 {
    margin-left: 2%;

    @media (min-height: 1085px) {
      font-size: 25px; 
  }
  }
  
  h3 {
    margin-right: 4%;

    @media (min-height: 1085px) {
      font-size: 25px; 
    }
  }
`;

const CheckOutButton = styled.button`
  text-align: center;
  background: orange;
  cursor: pointer;
  font-weight: 500;
  font-size: 16px;
  min-width: 200px;
  min-height: 35px;
  margin-left: auto;
  margin-right: auto;
  border: 1px solid black;
  box-shadow: 0 0 0 1px rgb(0 0 0 / 15%), 0 0 0 rgb(0 0 0 / 20%);
  margin-top: 3%;
  margin-left: 10px;

  a {
    text-decoration: none;
    color: black;
  }

  @media(max-width: 768px) {
    font-size: 15px;
    font-size: 300;
    margin-left: 80px;
    margin-top: 5%;
  }

  @media (max-width: 880px) {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-right: 20px;
    padding-left: 20px;
    margin-left: 25%;
  }

  @media (min-height: 1085px) {
      font-size: 25px;
  }

  @media(max-width: 550px) {
    margin-left: 20%;
  }
`;

export default Subtotal